export default {
    'terms.title': 'ข้อกำหนดการใช้งาน',
} as Record<string, string>;
